import React from "react";
import { Card, CardHeader, ListGroup, ListGroupItem, Row, Col, Form, FormInput, FormSelect, Button } from "shards-react";
import { Link } from "react-router-dom";
import { FcAcceptDatabase, FcPlus } from "react-icons/fc";
import { TiDeleteOutline } from "react-icons/ti";
import FunctionDataService from "../../services/function.service";
import nav_store, { types as nav_types, actions as nav_actions } from "../../_stores/sidenav.store";
import { ToastContainer, toast } from "react-toastify";
import { actions as AppActions } from "../../_stores/app.store";

class CreateFunctionSuperAdmin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      functionName: "",
      procedureName: "",
      parameters: [],
      parameterSubmit: false,
      parameterName: { value: "", isValid: false },
      sorce: { value: "", isValid: false },
      dataType: { value: "", isValid: false },
    };

    this.onChangeFunctionName = this.onChangeFunctionName.bind(this);
    this.onChangeProcedureName = this.onChangeProcedureName.bind(this);

    this.onChangeParameterName = this.onChangeParameterName.bind(this);
    this.onChangeSource = this.onChangeSource.bind(this);
    this.onChangeDataType = this.onChangeDataType.bind(this);
    this.handleAddParameters = this.handleAddParameters.bind(this);
    this.deleteParameterName = this.deleteParameterName.bind(this);

    this.handleAddFunctionForm = this.handleAddFunctionForm.bind(this);
    this.handleUpdateFunctionForm = this.handleUpdateFunctionForm.bind(this);
  }

  componentDidMount() {
    console.log('this.props', this.props);
    if (this.props.functionId) this.retrieveFunctionDetails();
  }

  retrieveFunctionDetails() {
    FunctionDataService.get(this.props.functionId).then((response) => {
      var functionDetails = response.data.data;

      this.setState({
        functionName: functionDetails.functionName,
        procedureName: functionDetails.procedureName,
        parameters: functionDetails.parameters,
      });
    });
  }

  onChangeFunctionName(e) {
    this.setState({
      functionName: e.target.value,
    });
  }

  onChangeProcedureName(e) {
    this.setState({
      procedureName: e.target.value,
    });
  }

  onChangeParameterName(e) {
    let isValid = e.target.value ? true : false;
    this.setState({
      parameterName: {
        ...this.state.parameterName,
        value: e.target.value,
        isValid: isValid,
      },
    });
  }

  onChangeSource(e) {
    let isValid = e.target.value ? true : false;
    this.setState({
      source: {
        ...this.state.source,
        value: e.target.value,
        isValid: isValid,
      },
    });
  }

  onChangeDataType(e) {
    let isValid = e.target.value ? true : false;
    this.setState({
      dataType: {
        ...this.state.dataType,
        value: e.target.value,
        isValid: isValid,
      },
    });
  }

  handleAddParameters() {
    this.setState({
      parameterSubmit: true,
    });

    if (this.state.parameterName.isValid) {
      var parameters = {};
      parameters.parameterName = this.state.parameterName.value;
      parameters.source = this.state.source.value;
      parameters.dataType = this.state.dataType.value;

      this.setState({
        parameters: [...this.state.parameters, parameters],
        parameterName: {
          value: "",
          isValid: false,
        },
        parameterSubmit: false,
      });
    }
  }

  deleteParameterName(paramName) {
    var data = this.state.parameters.filter(function (item) {
      return item.parameterName !== paramName;
    });
    this.setState({
      parameters: data,
    });
  }

  newFunctionForm() {
    this.setState({
      functionName: "",
      procedureName: "",
      parameters: [],
    });
  }

  handleAddFunctionForm() {
    var data = {
      projectId: this.props.projectId,
      functionName: this.state.functionName,
      procedureName: this.state.procedureName,
      parameters: this.state.parameters,
    };
    AppActions.setLoading(true);
    FunctionDataService.create(data).then((response) => {
      AppActions.setLoading(false);
      if (response.data.success) {
        // check for success
        this.newFunctionForm();
        var notify_message = {
          type: "success",
          message: "Functions has been created successfully.",
        };
        nav_actions.setSideNav(nav_store.dispatch, {});
      } else {
        if (response.data.err.message) {
          // fields error
          var notify_message = {
            type: "error",
            message: response.data.err.message,
          };
        } else {
          // mongo error
          var notify_message = {
            type: "error",
            message: response.data.err.name + " - May be duplicate record",
          };
        }
      }
      this.props.redirectToFunctionDetails("/function/" + response.data.data.id, notify_message);
    });
  }

  handleUpdateFunctionForm() {
    var data = {
      functionName: this.state.functionName,
      procedureName: this.state.procedureName,
      parameters: this.state.parameters,
    };

    AppActions.setLoading(true);
    FunctionDataService.update(this.props.functionId, data).then((response) => {
      AppActions.setLoading(false);
      if (response.data.success) {
        // check for success
        this.newFunctionForm();
        var notify_message = {
          type: "success",
          message: "Function has been Updated successfully.",
        };
        nav_actions.setSideNav(nav_store.dispatch, {});
        this.props.redirectToFunctionDetails("/function/" + this.props.functionId, notify_message);
      } else {
        if (response.data.err.message) {
          // fields error
          var notify_message = {
            type: "error",
            message: response.data.err.message,
          };
        } else {
          // mongo error
          var notify_message = {
            type: "error",
            message: "Duplicate Function Name ",
          };
        }
        this.notify(notify_message.type, notify_message.message);
      }
    });
  }

  //this is for showing notification
  notify(type, message) {
    toast(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      type: type,
    });
  }

  render() {
    const { parameters } = this.state;
    const { functionId } = this.props;

    return (
      <div>
        <Card small className="mb-4">
          <CardHeader className="border-bottom">
            <h6 className="m-0">
              {functionId ? "Edit Transation Function" : "Create New Transation Function" }
              <Link className="btn btn-primary ml-4" to={"/view-function-superadmin"}><FcAcceptDatabase /> View All</Link>
            </h6>
            <h6 className="m-0"></h6>
          </CardHeader>
          <ListGroup flush>
            <ListGroupItem className="">
              <Form>
                <Row form>
                  {/* First Name */}
                  <Col md="12" className="form-group">
                    <Row className="form-group-row">
                      <Col className="form-label" md="3">
                        <label htmlFor="functionName">Function Name</label>
                      </Col>
                      <Col className="form-field" md="9">
                        <FormInput
                          id="functionName"
                          placeholder="Function Name"
                          value={this.state.functionName}
                          onChange={this.onChangeFunctionName}
                        />
                      </Col>
                    </Row>

                    <Row className="form-group-row">
                      <Col className="form-label" md="3">
                        <label htmlFor="procedureName">Stored Procedure Name</label>
                      </Col>
                      <Col className="form-field" md="9">
                        <FormInput
                          id="procedureName"
                          placeholder="Stored Procedure Name"
                          value={this.state.procedureName}
                          onChange={this.onChangeProcedureName}
                        />
                      </Col>
                    </Row>

                    <Row className="form-group-row border-bottom-button">
                      <Col className="form-label" md="3">
                        <label htmlFor="masterTransactionFields">Stored Procedure Parameters </label>
                      </Col>
                      <Col className="form-field" md="9">
                        <Row>
                          <Col className="form-field" md="5">
                            <label htmlFor="parameterName">Parameter Name</label>
                            <FormInput
                              id="parameterName"
                              placeholder="Parameter Name"
                              value={this.state.parameterName.value}
                              onChange={this.onChangeParameterName}
                              className={
                                this.state.parameterSubmit ? (this.state.parameterName.isValid ? "" : "field-error") : ""
                              }
                            />
                          </Col>
                          <Col className="form-field" md="3">
                            <label htmlFor="source">Source</label>
                            <FormSelect
                              id="source"
                              onChange={this.onChangeSource}
                              className={this.state.parameterSubmit ? (this.state.source.isValid ? "" : "field-error") : ""}
                            >
                              <option value="">Select Source</option>
                              <option value="FieldName">FieldName</option>
                              <option value="CustomValue">CustomValue</option>
                              <option value="MasterFieldName">MasterFieldName</option>
                            </FormSelect>
                          </Col>

                          <Col className="form-field" md="3">
                            <label htmlFor="dataType">Data Type</label>
                            <FormSelect
                              id="dataType"
                              onChange={this.onChangeDataType}
                              className={
                                this.state.parameterSubmit ? (this.state.dataType.isValid ? "" : "field-error") : ""
                              }
                            >
                              <option value="">Select Data Type</option>
                              <option value="Number">Number</option>
                              <option value="String">String</option>
                              <option value="Date">Date</option>
                            </FormSelect>
                          </Col>

                          <Col className="form-field" md="1">
                            <Button variant="primary" onClick={this.handleAddParameters} className="mt-4">
                              <FcPlus size="16" />
                            </Button>
                          </Col>
                        </Row>

                        <Row className="form-group-row ml-1 mr-1 border-bottom-button">
                          <Col className="form-label" md="5">
                            <label htmlFor="parameterName">Parameter Name</label>
                          </Col>
                          <Col className="form-label" md="3">
                            <label htmlFor="source">Source</label>
                          </Col>
                          <Col className="form-label" md="3">
                            <label htmlFor="dataType">Data Type</label>
                          </Col>
                          <Col className="form-label" md="1">
                            <label htmlFor="dataType">Action</label>
                          </Col>
                        </Row>
                        {parameters &&
                          parameters.map((item, index) => {
                            return (
                              <Row className="form-group-row ml-1 mr-1 border-bottom-button" key={index + 1}>
                                <Col className="form-field" md="5">
                                  {item.parameterName}
                                </Col>
                                <Col className="form-field" md="3">
                                  {item.source}
                                </Col>
                                <Col className="form-field" md="3">
                                  {item.dataType}
                                </Col>
                                <Col className="form-label" md="1">
                                  <div
                                    className="closeBtn"
                                    onClick={() => this.deleteParameterName(item.parameterName)}
                                    aria-label="Close"
                                  >
                                    <TiDeleteOutline />
                                  </div>
                                </Col>
                              </Row>
                            );
                          })}
                      </Col>
                    </Row>

                    <Row className="form-group-row">
                      <Col className="form-button" md="4">
                        {functionId ? (
                          <Button
                            className="btn btn-primary float-left mr-3"
                            theme="accent"
                            onClick={this.handleUpdateFunctionForm}
                          >
                            <FcPlus /> Update
                          </Button>
                        ) : (
                          <Button variant="primary" className="float-left mr-3" onClick={this.handleAddFunctionForm}>
                            <FcPlus /> Create
                          </Button>
                        )}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Form>
            </ListGroupItem>
          </ListGroup>
        </Card>
        <ToastContainer />
      </div>
    );
  }
}

export default CreateFunctionSuperAdmin;
